import React, { useEffect, useState } from "react";
import styles from "./YearSelector.module.sass";
import { parseFilter } from "colbi_web_ui/lib/utils";
import SovosMonthSelector from "colbi_web_ui/lib/components/layout/YearSelector/index.js";
import { SovosMenuItem, SovosToolbarDropdown } from "mosaic-react";

export const calendarOptions = [
    { id: 1, name: "Fiscal Year", filterName: "fiscalyear" },
    { id: 2, name: "Calendar Year", filterName: "calendaryear" },
];

const getFilterData = (filterParsed, column) => {
    let itemFound;
    if (filterParsed?.length) {
        itemFound = filterParsed.find((item) => {
            if (item.column === column) {
                return true;
            }
            return false;
        });
    }

    return itemFound;
};

export const getDefaultYearType = (filter) => {
    const parsedFilter = parseFilter(filter);
    const year_type = getFilterData(parsedFilter, "year_type");

    if (year_type) {
        const value = year_type?.filters?.[0]?.value;

        if (value) {
            return calendarOptions.find((item) => {
                return item.filterName === value;
            });
        }
    } else {
        return calendarOptions[0];
    }
};

const YearSelector = ({
    years = [],
    selectedYearType = calendarOptions[0],
    selectedYear,
    setSelectedYearType,
    setSelectedYear,
    filter,
    loadingOverview,
}) => {
    const [yearOptions, setYearOptions] = useState({});
    const [filterParsed, setFilterState] = useState(null);
    const selectedYearOptions = selectedYearType?.filterName
        ? yearOptions[selectedYearType?.filterName]
        : [];

    const yearsArray = (selectedYearOptions || [])
        .map((item) => {
            return item.name; // Extracts the year as a string
        })
        .sort((a, b) => a.localeCompare(b));

    const buildYearOptions = (years) => {
        const fiscalYears = (years?.fiscalyear || []).map((item, id) => {
            return { id: id + 1, name: item };
        });

        const calendarYears = (years?.calendaryear || []).map((item, id) => {
            return { id: id + 1, name: item };
        });

        const calendarMapObj = {
            fiscalyear: fiscalYears,
            calendaryear: calendarYears,
        };

        return calendarMapObj;
    };

    useEffect(() => {
        if (years && !loadingOverview) {
            const yearOptions = buildYearOptions(years);
            setYearOptions(yearOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(years)]);

    useEffect(() => {
        const parsedFilter = parseFilter(filter);
        const year = getFilterData(parsedFilter, "year");

        if (year && filterParsed !== filter && selectedYearOptions?.length) {
            const value = year?.filters?.[0]?.value;

            if (value) {
                const newOption =
                    (selectedYearOptions || []).find((item) => {
                        return item.name === value;
                    }) || null;

                if (!newOption) {
                    setSelectedYear(selectedYearOptions?.[0]);
                } else if (newOption && selectedYear?.name !== newOption?.name) {
                    setSelectedYear(newOption);
                }

                setFilterState(filter);
            }
        } else if (selectedYearOptions?.[0]) {
            // default item
            setSelectedYear(selectedYearOptions?.[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, selectedYearOptions]);

    useEffect(() => {
        const parsedFilter = parseFilter(filter);
        const year_type = getFilterData(parsedFilter, "year_type");

        if (year_type) {
            const value = year_type?.filters?.[0]?.value;

            if (value) {
                const newOption = calendarOptions.find((item) => {
                    return item.filterName === value;
                });

                if (selectedYearType?.filterName !== newOption?.filterName) {
                    setSelectedYearType(newOption);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    return (
        <div className={styles["year-selector"]}>
            <>
                <SovosMonthSelector
                    className={`${styles["sovos-month-selector"]}`}
                    format={"number"}
                    selectedYear={+selectedYear?.name || null}
                    nextMonthTooltipText={"Next"}
                    previousMonthTooltipText={"Previous"}
                    years={yearsArray}
                    minDate={new Date(`${yearsArray[0]}-01-01`)}
                    maxDate={new Date(`${yearsArray[yearsArray.length - 1]}-12-31`)}
                    onChange={(e) => {
                        const optionSelected = selectedYearOptions.find(
                            (item) => item.name === e.year,
                        );

                        if (optionSelected) {
                            setSelectedYear(optionSelected);
                        }
                    }}
                />
                <SovosToolbarDropdown
                    label="Select a Year Type"
                    value={selectedYearType?.filterName}
                    onChange={({ target }) => {
                        const { value } = target || {};

                        const optionSelected = calendarOptions.find(
                            (item) => item.filterName === value,
                        );
                        const yearOptionsParsed = value ? yearOptions[value] : [];

                        setSelectedYear(yearOptionsParsed?.[0]);
                        setSelectedYearType(optionSelected);
                    }}
                >
                    {calendarOptions.map((item, index) => {
                        return <SovosMenuItem value={item.filterName} key={index}>{item.name}</SovosMenuItem>;
                    })}
                </SovosToolbarDropdown>
            </>
        </div>
    );
};

export default YearSelector;
